import React from "react";
import { motion } from "framer-motion";

const posts = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&q=80&w=600&h=400",
    date: "MARCH 15, 2026",
    title: "The Future of Digital Payments: What Businesses Need to Know"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&q=80&w=600&h=400",
    date: "MARCH 09, 2026",
    title: "How to Effectively Protect Your Business from Payment Fraud"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1556740738-b6a63e27c4df?auto=format&fit=crop&q=80&w=600&h=400",
    date: "MARCH 04, 2026",
    title: "Why Real-Time Payments Are the Essential New Standard"
  }
];

export default function Blog() {
  return (
    <section className="w-full bg-[#F6F7F6] py-24 md:py-32 px-4 md:px-8">
      <link href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;700&display=swap" rel="stylesheet" />
      <div className="max-w-[1240px] mx-auto">
        <div className="text-center mb-16 md:mb-24">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="text-[72px] font-['Anton',sans-serif] font-normal text-black uppercase leading-[80px] max-w-[1000px] mx-auto tracking-normal whitespace-nowrap"
          >
            STAY AHEAD IN THE WORLD<br />
            OF DIGITAL PAYMENTS
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-6 lg:gap-8">
          {posts.map((post, index) => (
            <motion.div
              key={post.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group cursor-pointer flex flex-col"
            >
              <div className="w-full aspect-[4/3] rounded-[24px] overflow-hidden mb-6 relative">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="px-2">
                <p className="text-[14px] text-gray-500 font-medium uppercase tracking-wider mb-3">
                  {post.date}
                </p>
                <h3 className="text-[22px] md:text-[24px] font-bold text-[#073634] leading-[1.3] group-hover:underline underline-offset-4">
                  {post.title}
                </h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}